import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

const sortStarts = (starts = []) => sortBy(starts, [start => start.horse_name]);

export const groupStarts = starts =>
  groupBy(sortStarts(starts), start => start.horse_name[0]);

export const searchFilter = (starts, query) => {
  const q = query.toLowerCase();
  return starts.filter(start => start.horse_name.toLowerCase().includes(q));
};
